import { defineComponent, reactive, SetupContext } from '@vue/composition-api';
import MessageConst from '@/shared/message-const';

// リアクティブな変数の型定義
export type reactiveData = {
    displayMessage: string;
}

/**
 * エラー画面コンポーネント
 *
 * 致命的エラー(401、404、500など)が発生した場合に表示する
 */
export default defineComponent({
    setup(props, ctx: SetupContext) {
        const state: reactiveData = reactive<reactiveData>({
            displayMessage: ''
        })

        /**
         * created ライフサイクルフック
         * エラーのHTTPステータスコードを取得する。
         */
        created();
        async function created() {
            // メッセージ設定
            if (ctx.root.$store.state.errorMessage === '') {
                // システムエラー
                state.displayMessage = MessageConst.E_SYSTEM_ERROR;
            } else {
                state.displayMessage = ctx.root.$store.state.errorMessage
            }
        }

        /**
         * トップページのパス切り替え:to="getTopPagePath()"
         */
        function getTopPagePath() {
            if (ctx.root.$store.state.topPagePath === '') {
                return '/';
            } else {
                // パスが設定されていた場合、設定されていたパスに遷移する
                return ctx.root.$store.state.topPagePath;
            }
        }

        /**
         * SAML認証状態取得
         */
         function getSamlAuthenticationStatus() {
            return ctx.root.$store.state.isSamlAuthenticationStatus;
        }

        return {
            state,
            getTopPagePath,
            getSamlAuthenticationStatus
        }
    }
})
